module.exports = __webpack_public_path__ + "img/img-4.46559151.png";